var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMailWhite = function SvgMailWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.044,
    height: 20.048,
    viewBox: "0 0 20.044 20.048",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-white-icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_4",
    "data-name": "Exclusion 4",
    d: "M-3856.293,1274.048h-11.363a4.319,4.319,0,0,1-3.072-1.276A4.315,4.315,0,0,1-3872,1269.7v-11.356a4.365,4.365,0,0,1,1.269-3.075,4.3,4.3,0,0,1,3.064-1.269h11.378a4.3,4.3,0,0,1,3.064,1.269,4.367,4.367,0,0,1,1.27,3.075V1269.7a4.364,4.364,0,0,1-1.269,3.077A4.309,4.309,0,0,1-3856.293,1274.048Zm-8.459-9.6h0l-4.484,4.484a1.093,1.093,0,0,0,.55.149h13.462a1.146,1.146,0,0,0,.56-.149l-4.489-4.484-1.1,1.1a2.3,2.3,0,0,1-1.593.638l-.107,0-.116,0a2.268,2.268,0,0,1-1.583-.638l-1.1-1.1Zm-4.9-4.894h0a1.092,1.092,0,0,0-.148.56v7.847a1.146,1.146,0,0,0,.149.56l4.484-4.484-4.484-4.483Zm15.374,0h0l-4.483,4.483,4.483,4.483a.85.85,0,0,0,.149-.559v-7.847a1.147,1.147,0,0,0-.15-.56Zm-14.41-.561a1.135,1.135,0,0,0-.56.149l6,6a1.954,1.954,0,0,0,1.29.485,1.954,1.954,0,0,0,1.29-.485l6-6a1.143,1.143,0,0,0-.563-.149h-13.456Z",
    transform: "translate(3872 -1254)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMailWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mail-white.1dc85755.svg";
export { ForwardRef as ReactComponent };